import styled from "styled-components";
import {useState} from "react";
import { useApp } from "../../contexts";
import { MobileContainer } from "../Container";
import { SettingIcon } from "../Icons/SettingIcon";
import { ArrowDownIcon } from "../Icons/ArrowDownIcon";
import { MyPuchaseIcon } from "../Icons/MyPuchaseIcon";
import { MyAffiliateIcon } from "../Icons/MyAffiliateIcon";
import { ProfileIcon } from "../Icons/ProfileIcon";
import { SignoutIcon } from "../Icons/SignoutIcon";
import { useNavigate } from "react-router-dom";
import useAffiliate from "../../hook/useAffiliate";
import { ModalPolicy } from "../AffiliateComponent/ModalPolicy";

const Close = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: -8px;

  @media screen and (max-width: 1024px) {
    & > svg {
      width: 24px;
      height: 24px;
    }
  }
`;

const MContainer = styled.div`
  overflow: auto;
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0px;
  background: #fff;
  padding: 14px 22px 20px;
`;
const MContainerTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  width: calc(100% + 44px);
  margin-left: -22px;
  margin-right: -22px;
  background: #0000001A;
  @media screen and (max-width: 1024px) {
    & {
    }
  }
`;
const MContainerBody = styled.div`
  margin: 25px 0 27px 0;
`;
const MContainerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: calc(100% - 44px);
  text-align: center;
  bottom: 30px;
`;
const MMenu = styled.div`
  min-height: calc(100vh - 197px);
`;
const MMenuSubTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 55px;
  position: relative;
  width: 100%;
  & > span {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    display: flex;
  }
  & > svg {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }
  & > .arrow-icon{
    position: absolute;
    right: 0;
    svg{
      width: 12px;
    }
    &.active{
      svg{
        transform: rotate(180deg);
      }
    }
  }
`;
const MMenuSubs = styled.div`
  display: none;
  &.active {
    display: block;
    width: 100%;
  }
`;
const MMenuSubItem = styled.a`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    line-height: 35px;
    color: #000 !important;
    padding-left: 40px;
    font-size: 16px;
    gap: 16px;
    &:last-of-type{
      margin-bottom: 15px;
    }
`;

const MMenuItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 55px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  position: relative;
  &:last-of-type{
    border-bottom: none;
  }

  & > svg {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }

  & > span {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    display: flex;
  }

  & > .checker {
    position: absolute;
    right: 0;
    height: 24px;

    svg {
      height: 24px;
    }
  }
  &.hasSubs {
    flex-wrap: wrap;
    height: unset;
  }
`;

const MUser = styled.div`
  background: url("/assets/images/sidebar-profile-bg.svg");
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px 20px;
  width: 100%;
`;

export const MUserAvt = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 12px;

  & img {
    width: 100%;
    height: 100%;
  }
`;

const MUserInfo = styled.div`
  max-width: calc(100vw - 60px);
  & h1 {
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: #000;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & p {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    display: inline-block;
    max-width: 205px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #000;
  }

  &.minimized {
    & h1 {
      max-width: 140px;
    }

    & p {
      max-width: 140px;
    }
  }
`;

const EyeMemberBadge = styled.div`
  background: url("/assets/images/eye-member-badge.svg");
  height: 78px;
  width: 71.1px;
`;

const SidebarUserMobile = (props) => {
  const { logout, T, user } = useApp();
  const [groupMenuStatus, setGroupMenuStatus] = useState({'settings': false}) 
  const navigate = useNavigate();
  const {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy,
  } = useAffiliate();
  const handleRedirectAuth = (e, path) => {
    e.preventDefault();
    navigate(path);
    props?.onClose()
  };
  const handleToggleMenu = (e, key) => {
    e.preventDefault();
    const changeData = {}
    for (let item in groupMenuStatus) {
        if (item == key) {
            changeData[item] = !groupMenuStatus[item]
        } else {
            changeData[item] = false
        }
    }
    setGroupMenuStatus(changeData)
  };

  const hasEyeMemberBadge = user?.eyeMemberLabel;

  return (
    <MContainer>
      <div className="flex justify-end">
        <Close onClick={props.onClose}>
          <MCloseIcon />
        </Close>
      </div>
      <MContainerTop>
        <MUser>
          <div className="flex items-center">
            <MUserAvt>
              <img
                alt="Avatar"
                className="object-cover h-full w-full"
                onError={(event) => {
                  event.target.onerror = null;
                  event.target.setAttribute("data-image", event.target.src);
                  event.target.src =
                    "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                }}
                src={
                  user?.avatar?.trim() ||
                  "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                }
              />
            </MUserAvt>
            <MUserInfo className={`${hasEyeMemberBadge ? 'minimized' : ''}`}>
              <h1>{user?.name?.trim() || ""}</h1>
              <p>{user?.email?.trim() || ""}</p>
            </MUserInfo>
          </div>
          {hasEyeMemberBadge && <EyeMemberBadge/>}
        </MUser>
      </MContainerTop>
      <MContainerBody>
        <MMenu>
          <MMenuItem onClick={(e) => handleRedirectAuth(e, "/profile")}>
            <ProfileIcon />
            <span> {T("My Profile")}</span>
          </MMenuItem>
          <MMenuItem onClick={(e) => handleRedirectAuth(e, "/my-purchase")}>
            <MyPuchaseIcon />
            <span> {T("My Purchase")}</span>
          </MMenuItem>
          <MMenuItem onClick={(e) => onAffiliate()}>
            <MyAffiliateIcon />
            <span> {T("My Affiliate")}</span>
          </MMenuItem>
          <MMenuItem
            onClick={(e) => handleToggleMenu(e, "settings")}
            className="hasSubs"
          >
            <MMenuSubTitle>
              <SettingIcon />
              <span> {T("Settings")}</span>
              <span
                className={`arrow-icon ${
                  groupMenuStatus.settings ? "active" : ""
                }`}
              >
                <ArrowDownIcon />
              </span>
            </MMenuSubTitle>
            <MMenuSubs className={groupMenuStatus.settings ? "active" : ""}>
              <MMenuSubItem
                onClick={(e) => handleRedirectAuth(e, "/change-password")}
              >
                <M2ChangePassIcon />
                {T("Password")}
              </MMenuSubItem>
              <MMenuSubItem
                onClick={(e) => handleRedirectAuth(e, "/two-factor")}
              >
                <M2FAIcon />
                {T("2FA Authentication")}
              </MMenuSubItem>
              <MMenuSubItem
                onClick={(e) => handleRedirectAuth(e, "/payment-method")}
              >
                <M2PaymentIcon />
                {T("Payment method")}
              </MMenuSubItem>
              <MMenuSubItem
                onClick={(e) => handleRedirectAuth(e, "/address-book")}
              >
                <M2AddressBookIcon />
                {T("Address book")}
              </MMenuSubItem>
            </MMenuSubs>
          </MMenuItem>
          <MMenuItem onClick={logout}>
            <SignoutIcon />
            <span>{T("Sign out")}</span>
          </MMenuItem>
        </MMenu>
      </MContainerBody>
      <MContainerFooter>
        {T("© 2025 AI Avatar Pte. Ltd. All rights reserved.")}
      </MContainerFooter>
      {isOpenModalPolicy && (
        <ModalPolicy
          onClose={() => setIsOpenModalPolicy(false)}
          handleSubmit={() => onConfirmPolicy()}
        ></ModalPolicy>
      )}
    </MContainer>
  );
};

export default function SidebarUser(props) {
  return (
    <>
      <MobileContainer>
        <SidebarUserMobile {...props} />
      </MobileContainer>
    </>
  );
}

const MCloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M20.4404 3.22021L3.44043 20.2202" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.44043 3.22021L20.4404 20.2202" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
const M2FAIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15" fill="none">
    <path d="M12.8994 3.87753C12.8904 3.47637 12.8814 3.09265 12.8814 2.72637C12.8814 2.43858 12.6394 2.20311 12.3435 2.20311C10.0394 2.20311 8.29109 1.55776 6.82971 0.179855C6.6235 -0.0207264 6.29178 -0.0207264 6.0766 0.179855C4.62419 1.55776 2.86695 2.20311 0.571776 2.20311C0.275914 2.20311 0.0338447 2.43858 0.0338447 2.72637C0.0338447 3.09265 0.0248792 3.47637 0.0159137 3.87753C-0.0558105 7.63625 -0.154431 12.7816 6.28281 14.9444C6.3366 14.9618 6.39936 14.9706 6.46212 14.9706C6.52488 14.9706 6.57867 14.9618 6.64143 14.9444C13.0697 12.7816 12.9711 7.63625 12.8994 3.87753ZM6.45316 13.9066C0.930397 11.9531 1.02005 7.67986 1.09178 3.90369C1.09178 3.67695 1.10074 3.45893 1.10074 3.2409C3.25247 3.15369 4.97384 2.51706 6.45316 1.26997C7.93247 2.51706 9.65384 3.15369 11.8056 3.2409C11.8056 3.45893 11.8145 3.67695 11.8145 3.90369C11.8952 7.67986 11.9759 11.9531 6.45316 13.9066Z" fill="#818181"/>
  </svg>
);
const M2PaymentIcon = () => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.787354 3.72454C0.787354 2.69945 0.787354 2.18691 0.990009 1.79678C1.16079 1.46803 1.42884 1.19997 1.7576 1.02919C2.14773 0.826538 2.66027 0.826538 3.68535 0.826538H12.6033C13.6284 0.826538 14.1409 0.826538 14.531 1.02919C14.8598 1.19997 15.1278 1.46803 15.2986 1.79678C15.5013 2.18691 15.5013 2.69945 15.5013 3.72454V7.90592C15.5013 8.93101 15.5013 9.44355 15.2986 9.83368C15.1278 10.1624 14.8598 10.4305 14.531 10.6013C14.1409 10.8039 13.6284 10.8039 12.6033 10.8039H3.68535C2.66027 10.8039 2.14773 10.8039 1.7576 10.6013C1.42884 10.4305 1.16079 10.1624 0.990009 9.83368C0.787354 9.44355 0.787354 8.93101 0.787354 7.90592V3.72454Z" stroke="#666666"/>
  <path d="M0.787354 4.15235L15.5013 4.15235" stroke="#666666" stroke-linecap="round"/>
  <ellipse cx="3.38393" cy="8.30952" rx="0.432762" ry="0.415724" fill="#666666"/>
  </svg>

);
const M2AddressBookIcon = (props) => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M17.5 6.125L3.5 6.125" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M13.125 10.5L3.5 10.5" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M7.875 14.875H3.5" stroke="black" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/>
  </svg>

);
const M2ChangePassIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
    <path d="M10.5 15H1.5C0.675 15 0 14.3711 0 13.5937V7.03125C0 6.25391 0.675 5.625 1.5 5.625H10.5C11.325 5.625 12 6.25391 12 7.03125V13.5937C12 14.3711 11.325 15 10.5 15ZM1.5 6.5625C1.225 6.5625 1 6.77344 1 7.03125V13.5937C1 13.8516 1.225 14.0625 1.5 14.0625H10.5C10.775 14.0625 11 13.8516 11 13.5937V7.03125C11 6.77344 10.775 6.5625 10.5 6.5625H1.5Z" fill="#818181"/>
    <path d="M9.5 6.5625C9.225 6.5625 9 6.35156 9 6.09375V3.75C9 2.19922 7.65417 0.9375 6 0.9375C4.34583 0.9375 3 2.19922 3 3.75V6.09375C3 6.35156 2.775 6.5625 2.5 6.5625C2.225 6.5625 2 6.35156 2 6.09375V3.75C2 1.68359 3.79583 0 6 0C8.20417 0 10 1.68359 10 3.75V6.09375C10 6.35156 9.775 6.5625 9.5 6.5625Z" fill="#818181"/>
    <path d="M5.99984 10.625C5.2665 10.625 4.6665 10.0625 4.6665 9.375C4.6665 8.6875 5.2665 8.125 5.99984 8.125C6.73317 8.125 7.33317 8.6875 7.33317 9.375C7.33317 10.0625 6.73317 10.625 5.99984 10.625ZM5.99984 9.0625C5.8165 9.0625 5.6665 9.20313 5.6665 9.375C5.6665 9.54688 5.8165 9.6875 5.99984 9.6875C6.18317 9.6875 6.33317 9.54688 6.33317 9.375C6.33317 9.20313 6.18317 9.0625 5.99984 9.0625Z" fill="#818181"/>
    <path d="M6 12.5C5.725 12.5 5.5 12.2891 5.5 12.0312V10.3125C5.5 10.0547 5.725 9.84375 6 9.84375C6.275 9.84375 6.5 10.0547 6.5 10.3125V12.0312C6.5 12.2891 6.275 12.5 6 12.5Z" fill="#818181"/>
  </svg>
);
